import { colors } from '../colors'

const link = {
  baseStyle: {
    color: colors.brand.primary[500],
  },
}

export default link
